// Форма ответа фиксирована: её разбирают мобильное приложение и ТСД.
export type AppVersions = {
  iosUpdateUrl: string;
  iosVersion: string;
  minimalIosVersion: string;

  androidUpdateUrl: string;
  androidVersion: string;
  minimalAndroidVersion: string;

  tsdUpdateUrl: string;
  tsdVersion: string;
  minimalTsdVersion: string;

  isShowUpdate: boolean;
  isRequiredUpdate: boolean;

  isMaintenance: boolean;
  // null — техработы без объявленного срока окончания.
  maintenanceUntil: string | null;
};

export type PlatformKey = "ios" | "android" | "tsd";

export const PLATFORMS: {
  key: PlatformKey;
  title: string;
  urlField: keyof AppVersions;
  versionField: keyof AppVersions;
  minimalField: keyof AppVersions;
  urlPlaceholder: string;
}[] = [
  {
    key: "ios",
    title: "iOS",
    urlField: "iosUpdateUrl",
    versionField: "iosVersion",
    minimalField: "minimalIosVersion",
    urlPlaceholder: "https://apps.apple.com/…",
  },
  {
    key: "android",
    title: "Android",
    urlField: "androidUpdateUrl",
    versionField: "androidVersion",
    minimalField: "minimalAndroidVersion",
    urlPlaceholder: "https://play.google.com/…",
  },
  {
    key: "tsd",
    title: "ТСД",
    urlField: "tsdUpdateUrl",
    versionField: "tsdVersion",
    minimalField: "minimalTsdVersion",
    urlPlaceholder: "https://play.google.com/…",
  },
];

// Версия вида 1.0.13: сравнение на клиенте посегментное, буквы и суффиксы сломают его.
export const VERSION_PATTERN = /^\d+(\.\d+){0,3}$/;
